import { toast } from 'react-toastify';
import appApi from '../../../../api/app-api';
import { ProgramType } from '../../../../api/types/programs/program.type';

export const updateProgramNotesOperation = async (
  branchId: number | undefined,
  programId: number | undefined,
  notes: string,
  setLoading: (loading: boolean) => any,
  programType: ProgramType,
  setProgramType: (program: ProgramType) => any,
) => {
  try {
    if (isNaN(Number(branchId)) || isNaN(Number(programId))) {
      toast.warn(
        'לא ניתן לאתר את מזהה השלוחה או התוכנית המבוקשת, נסה שוב בעוד מספר רגעים',
      );
      return;
    }
    setLoading(true);
    await appApi.updateProgramNotes(branchId!, programId!, notes);
    const updatedProgramType = {
      ...programType,
      metadata: {
        ...programType.metadata,
        notes: notes, // Update the notes in metadata
      },
    };
    setProgramType(updatedProgramType);
    toast.success('ההערות עודכנו בהצלחה');
    setLoading(false);
  } catch (e) {
    setLoading(false);
    console.error(`updateProgramNotesOperation is failed with the error: ${e}`);
    toast.error('עדכון ההערות נכשל, נסה שוב בעוד מספר רגעים');
  }
};
